module.exports = __webpack_public_path__ + "static/media/centurion-logo-charcoal.b60a3721.svg";